<template>
    <transition name="fade">
        <div class="processar" role="dialog" v-show="exibir">
            <div id="text1" >
                <strong id="txtCarregando" tabindex="-1">{{text}}...</strong><br />
                <br />
                <i class="fas fa-sync-alt fa-spin fa-4x"></i>
            </div>
        </div>
    </transition>
</template>

<script>
import bus from '@/service/bus'
export default {
    data: function () {
        return {
            exibir: false,
            text: ""
        }
    },
    mounted: function(){
        bus.$on('load-in', obj=>{
            this.exibir = true
            this.text = obj.text
            setTimeout(() => {
                let d = document.getElementById('txtCarregando')
                d.focus()
            }, 0)
        })

        bus.$on('load-out', ()=>{
            this.exibir = false
        })
    },
    beforeDestroy: function(){
        bus.$off('load-in')
        bus.$off('load-out')
    }
}
</script>

<style>

.processar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .9;
    background-color: #000;
    z-index: 2000;
}

    .processar div {
        top: 36%;
        left: 50%;
        margin-left: -200px; /* A metade de sua largura. */
        position: absolute;
        width: 400px;
        color: #FFF;
        text-align: center;
    }
</style>
